import React, { useCallback, useMemo } from 'react';

import { POS_TYPE } from '../../../common/constants';
import { getFullMachineName } from '../../../common/utils/machine';
import { ListRow } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const PointOfSaleListItem = ({
	item: pointOfSale,
	customProps,
}) => {
	const styles = useThemedStyles(createStyles);
	const { onPressItem } = customProps || {};

	const pointOfSaleName = useMemo(() => {
		return getFullMachineName(pointOfSale, pointOfSale.place, pointOfSale.location);
	}, [pointOfSale]);

	const onPress = useCallback(() => {
		if (onPressItem) {
			onPressItem(pointOfSale);
		}
	}, [pointOfSale, onPressItem]);

	const typeLabel = pointOfSale.type === POS_TYPE.MARKET ? 'Market' : 'Machine';

	return (
		<ListRow
			title={pointOfSaleName}
			subtitle={`Type: ${typeLabel} · Client: ${pointOfSale.location?.client?.name || 'No client'}`}
			value={pointOfSale.isInactive ? 'Inactive' : undefined}
			onPress={onPress}
			style={styles.row}
		/>
	);
};

const createStyles = ({ ui: { space } }) => ({
	row: {
		marginHorizontal: space.gutter,
		marginBottom: space.sm,
	},
});

export default PointOfSaleListItem;
